import _typeof from "@babel/runtime/helpers/esm/typeof";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _toArray from "@babel/runtime/helpers/esm/toArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "style"],
    _excluded2 = ["className", "style"],
    _excluded3 = ["children"],
    _excluded4 = ["className"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { isValidElement, PureComponent } from 'react';
import PropTypes from 'prop-types';
import ResizeObserver from 'resize-observer-polyfill';
import classNames from '@jd/jmtd-tools/es/classnames';
import { css, px, remove as removeCss } from '@jd/jmtd-tools/es/css';
import { bubble, setClass } from '@jd/jmtd-tools/es/element';
import { isNumber, isObject, isString } from '@jd/jmtd-tools/es/is';
import { getMaxLevel } from '@jd/jmtd-tools/es/tree';
import { every, findFirst } from '@jd/jmtd-tools/es/generator';
import refresh from '@jd/jmtd-tools/es/refresh';
import { loadFont } from '@jd/jmtd-tools/es/font';
import Loading from '../Loading';
import { getObjectValue, getValue, isEmpty } from '../tools/util';
import Tooltip from '../Tooltip';
import Empty from '../Empty';
import { ON_TH_CLICK, TH_DECORATOR, TH_TOOLTIP, TD_DECORATOR, defaultColumnRender, CUSTOM_ROW, getAffixAlign, flat, hasChildren, TH_PROPS, EMPTY_ROW, CUSTOM_CELL } from './common';
var COLUMN = Symbol('column');
var ROW = Symbol('row');
var AFFIX_INFO = Symbol('affixInfo');
var COLUMN_INDEX = Symbol('columnIndex');
var RowClassName = 'jmtd-table-row'; // 预加载字体

loadFont('Roboto-jmt');
loadFont('Roboto-Medium-jmt');
/**
 * 合并参数
 */

function combineProps(props1, props2) {
  var _ref = props1 !== null && props1 !== void 0 ? props1 : {},
      className1 = _ref.className,
      style1 = _ref.style,
      other1 = _objectWithoutProperties(_ref, _excluded);

  var _ref2 = props2 !== null && props2 !== void 0 ? props2 : {},
      className2 = _ref2.className,
      style2 = _ref2.style,
      other2 = _objectWithoutProperties(_ref2, _excluded2);

  return _objectSpread(_objectSpread({
    className: classNames(className1, className2),
    style: _objectSpread(_objectSpread({}, style1), style2)
  }, other1), other2);
}

function getSize(el) {
  var _window$getComputedSt = window.getComputedStyle(el),
      height = _window$getComputedSt.height,
      width = _window$getComputedSt.width;

  return {
    width: parseFloat(width),
    height: parseFloat(height)
  };
}

function Cell(_ref3) {
  var column = _ref3.column,
      children = _ref3.children,
      empty = _ref3.empty,
      _ref3$props = _ref3.props,
      cellProps = _ref3$props === void 0 ? {} : _ref3$props,
      cellClassName = _ref3.className,
      borderLeft = _ref3.borderLeft,
      borderRight = _ref3.borderRight,
      CellTag = _ref3.CellTag,
      cellRef = _ref3.cellRef,
      _onClick = _ref3.onClick,
      tooltip = _ref3.tooltip,
      extraStyle = _ref3.extraStyle,
      customCell = _ref3[CUSTOM_CELL],
      otherProps = _objectWithoutProperties(_ref3, ["column", "children", "empty", "props", "className", "borderLeft", "borderRight", "CellTag", "cellRef", "onClick", "tooltip", "extraStyle", CUSTOM_CELL].map(_toPropertyKey));

  var affix = column.affix,
      align = column.align,
      columnClassName = column.className,
      monoSpaced = column.monoSpaced,
      drag = column.drag;
  var props = {}; // 检测单元格是否被hover
  // 如果hover到了单元格内部的data-catch元素，则单元格不处于hover状态

  function checkHover(e) {
    return every(bubble(e.target, e.currentTarget), function (el) {
      return !el.hasAttribute('data-catch');
    });
  } // 处理单元格点击事件
  // onMouseMove、onMouseLeave用于检测单元格hover状态


  if (_onClick.length) {
    Object.assign(props, {
      onMouseMove: function onMouseMove(e) {
        setClass(e.currentTarget, 'jmtd-table-cell-hover', checkHover(e));
      },
      onMouseLeave: function onMouseLeave(e) {
        e.currentTarget.classList.remove('jmtd-table-cell-hover');
      },
      onClick: function onClick(e) {
        if (checkHover(e)) {
          _onClick.forEach(function (callback) {
            return callback(e);
          });
        }
      }
    });
  }

  var renderedProps = [otherProps, props, cellProps, {
    className: classNames('jmtd-table-cell', {
      'jmtd-table-cell-affix': affix && !customCell,
      'jmtd-table-cell-border-left': borderLeft,
      'jmtd-table-cell-border-right': borderRight,
      'jmtd-table-cell-affix-left': getAffixAlign(affix) === 'left' && !customCell,
      'jmtd-table-cell-affix-right': affix === 'right' && !customCell,
      'jmtd-table-cell-align-center': align === 'center',
      'jmtd-table-cell-align-right': align === 'right',
      'jmtd-table-cell-monospaced': monoSpaced,
      'jmtd-table-cell-drag': drag
    }, cellClassName, columnClassName),
    style: extraStyle
  }].reduce(combineProps); // 渲染单元格

  var inner = empty ? null : /*#__PURE__*/React.createElement(CellTag, _extends({}, renderedProps, {
    ref: function ref(el) {
      if (el) {
        cellRef(el);
      }
    }
  }), children);
  return tooltip ? /*#__PURE__*/React.createElement(Tooltip, {
    theme: "light",
    placement: "top",
    title: tooltip
  }, inner) : inner;
}

Cell.propTypes = {
  CellTag: PropTypes.string.isRequired,
  cellRef: PropTypes.func,
  column: PropTypes.object.isRequired,
  tooltip: PropTypes.node,
  onClick: PropTypes.array,
  className: PropTypes.any,
  borderLeft: PropTypes.bool,
  borderRight: PropTypes.bool,
  props: PropTypes.object,
  children: PropTypes.node,
  empty: PropTypes.bool,
  extraStyle: PropTypes.object
};
Cell.defaultProps = {
  tooltip: null,
  onClick: [],
  cellRef: function cellRef() {},
  props: {},
  className: null,
  children: null,
  borderLeft: false,
  borderRight: false,
  empty: false,
  extraStyle: null
};

var TableKernel = /*#__PURE__*/function (_PureComponent) {
  _inherits(TableKernel, _PureComponent);

  var _super = _createSuper(TableKernel);

  function TableKernel() {
    _classCallCheck(this, TableKernel);

    return _super.apply(this, arguments);
  }

  _createClass(TableKernel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      var ref = this.ref;
      this.componentDidUpdate(); // 如果table尺寸变化，重新计算尺寸

      var resizeObserver = this.resizeObserver = new ResizeObserver(function () {
        var size = getSize(_this.wrapperRef || ref);

        if (_this.tableWidth !== Math.floor(size.width)) {
          _this.resize(size);
        }
      });
      resizeObserver.observe(ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var fAffixHeader = this.fAffixHeader,
          affixHeaderValue = this.affixHeaderValue;
      this.removeRefresh();
      this.resize(getSize(this.wrapperRef || this.ref)); // 处理头吸附

      if (fAffixHeader) {
        this.refreshHandle = refresh(function () {
          var ref = _this2.ref,
              theadRef = _this2.theadRef,
              headerPlaceholderRef = _this2.headerPlaceholderRef;

          if (!ref || !theadRef) {
            return;
          }

          var _ref$getBoundingClien = ref.getBoundingClientRect(),
              top = _ref$getBoundingClien.top,
              bottom = _ref$getBoundingClien.bottom;

          var _theadRef$getBounding = theadRef.getBoundingClientRect(),
              headerHeight = _theadRef$getBounding.height; // 计算是否属于吸附状态


          var affixed = bottom - affixHeaderValue >= headerHeight && top <= affixHeaderValue; // 更新占位头部高度

          if (_this2.headerHeight !== headerHeight) {
            _this2.headerHeight = headerHeight;
            css(headerPlaceholderRef, 'height', px(theadRef.offsetHeight));
          } // 更新头部吸顶


          if (_this2.headerAffixed !== affixed) {
            _this2.headerAffixed = affixed;
            setClass(ref, 'jmtd-table-header-affixed', affixed);

            _this2.checkScrollX();
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeRefresh();
      this.resizeObserver.disconnect();
    }
  }, {
    key: "removeRefresh",
    value: function removeRefresh() {
      if (this.refreshHandle) {
        this.refreshHandle.remove();
        delete this.headerAffixed;
      }
    } // 计算表格尺寸

  }, {
    key: "resize",
    value: function resize(_ref4) {
      var _this3 = this;

      var offsetWidth = _ref4.width,
          offsetHeight = _ref4.height;
      var _ref5 = [Math.floor(offsetWidth), Math.ceil(offsetHeight)];
      offsetWidth = _ref5[0];
      offsetHeight = _ref5[1];

      var ref = this.ref,
          tableRef = this.tableRef,
          theadRef = this.theadRef,
          thRef = this.thRef,
          columnsRef = this.columnsRef,
          colRefs = this.colRefs,
          fAffixHeader = this.fAffixHeader,
          _this$rowsRef = _toArray(this.rowsRef),
          bodyRowsRef = _this$rowsRef.slice(1),
          flatColumns = this.flatColumns,
          _this$props = this.props,
          noAutoRowHeight = _this$props.noAutoRowHeight,
          scrollY = _this$props.scrollY; // 如果列为空或者没有尺寸，不计算


      if (flatColumns.length > 0 && offsetWidth) {
        (function () {
          var _this3$lastScrollLeft;

          var _this3$affixCells = _this3.affixCells,
              affixCells = _this3$affixCells === void 0 ? [] : _this3$affixCells;
          affixCells.forEach(function (el) {
            delete el[AFFIX_INFO];
            el.classList.remove('jmtd-table-cell-affixed');
            removeCss(el, ['left', 'right']);
          });
          affixCells = _this3.affixCells = [];
          ref.classList.add('jmtd-table-test'); // 设置最小高度防止表格跳动

          css(ref, 'min-height', px(offsetHeight));
          var calcColumns = _this3.calcColumns = [];
          var maxContentColumns = [];
          var fixedWidth = 0;
          var allWidthFixed = true; // 所有列的宽度都固定

          var unfixedWidth = 0; // 内容宽度

          var flexGrowColumns = [];
          var maxFlexGrowWidth = 0;
          var minFlexGrowWidth = 0;
          var columnLength = flatColumns.length;
          thRef.forEach(function (el, index) {
            var _el$COLUMN = el[COLUMN],
                width = _el$COLUMN.width,
                minWidth = _el$COLUMN.minWidth,
                maxWidth = _el$COLUMN.maxWidth,
                fitContent = _el$COLUMN.fitContent,
                fillAvailable = _el$COLUMN.fillAvailable,
                flexGrow = _el$COLUMN.flexGrow,
                affix = _el$COLUMN.affix;
            var calcColumn = calcColumns[index] = {
              affix: affix
            };
            var cellWidth = Math.ceil(getSize(el).width);
            var widthFixed = false;

            if (!flexGrow) {
              if (fitContent) {
                widthFixed = true;
              } else if (width) {
                if (isNumber(width)) {
                  // 固定宽度
                  cellWidth = width;
                } else if (isString(width)) {
                  var number = parseFloat(width);

                  if (width.endsWith('%')) {
                    // 百分比宽度
                    cellWidth = Math.floor(number / 100 * offsetWidth);
                  } else {
                    // 固定宽度
                    cellWidth = number;
                  }
                }

                widthFixed = true;
              } else if (fillAvailable) {
                maxContentColumns.push(calcColumn);
              } else {
                if (minWidth) {
                  cellWidth = Math.max(minWidth, cellWidth);
                }

                if (maxWidth) {
                  cellWidth = Math.min(maxWidth, cellWidth);
                  calcColumn.maxWidth = maxWidth;
                }
              }

              calcColumn.widthFixed = widthFixed && !(allWidthFixed && index === columnLength - 1);
              calcColumn.width = cellWidth;

              if (!widthFixed) {
                allWidthFixed = false;
                unfixedWidth += cellWidth;
              } else {
                fixedWidth += cellWidth;
              }
            } else {
              calcColumn.realWidth = cellWidth;
              calcColumn.flexGrowWidth = Math.min(flexGrow, cellWidth);
              maxFlexGrowWidth += cellWidth;
              minFlexGrowWidth += flexGrow;
              flexGrowColumns.push(calcColumn);
            }
          });
          var remindWidth = offsetWidth - fixedWidth - unfixedWidth; // 空余的宽度

          if (flexGrowColumns.length) {
            var max = remindWidth > maxFlexGrowWidth;
            var min = remindWidth < minFlexGrowWidth;
            var middle = !max && !min;
            var ratio = remindWidth / maxFlexGrowWidth;
            flexGrowColumns.forEach(function (column) {
              var flexGrowWidth = column.flexGrowWidth,
                  realWidth = column.realWidth;
              var width;

              if (max) {
                width = realWidth;
              } else if (middle) {
                width = Math.min(Math.ceil(realWidth * ratio), remindWidth);
              } else {
                width = flexGrowWidth;
              }

              remindWidth -= width;
              unfixedWidth += width;
              column.width = width;
            });
          } // 如果有多余的宽度，并且有maxColumns，平分多余宽度到maxColumns


          var maxContentColumnsLength = maxContentColumns.length;

          if (remindWidth > 0 && maxContentColumnsLength) {
            var avgAddedWidth = Math.ceil(remindWidth / maxContentColumnsLength);
            maxContentColumns.forEach(function (calcColumn) {
              var addWidth = Math.min(avgAddedWidth, remindWidth);
              calcColumn.width += addWidth;
              remindWidth -= addWidth;
            });
          } // 如果有多余的宽度，根据现有宽度分配这些宽度


          var _loop = function _loop() {
            var ratio = remindWidth / unfixedWidth; // 宽度比例
            // 遍历列，计算宽度
            // eslint-disable-next-line no-loop-func

            calcColumns.forEach(function (calcColumn) {
              var width = calcColumn.width,
                  widthFixed = calcColumn.widthFixed,
                  maxWidth = calcColumn.maxWidth; // 如果宽度不固定，根据比例放大

              if (!widthFixed) {
                var addedWidth = Math.min(Math.ceil(width * ratio), remindWidth);
                var newWidth = width + addedWidth; // 如果有最大宽度，放大结果不能超过最大宽度

                if (maxWidth && newWidth > maxWidth) {
                  newWidth = maxWidth;
                  calcColumn.widthFixed = true;
                  addedWidth = newWidth - width;
                  unfixedWidth -= newWidth;
                }

                calcColumn.width = newWidth;
                remindWidth -= addedWidth;
                unfixedWidth += addedWidth;
              }
            });
          };

          while (remindWidth > 0) {
            _loop();
          }

          var totalWidth = 0;
          calcColumns.forEach(function (_ref6, index) {
            var width = _ref6.width;
            css(colRefs[index], 'width', px(width)); // 如果表头吸顶，设置th的宽度

            if (fAffixHeader) {
              css(thRef[index], 'width', px(width));
            }

            totalWidth += width;
          }); // 总宽度

          css(tableRef, 'width', px(totalWidth));
          css(theadRef, 'width', px(totalWidth)); // 如果总宽度不大于容器宽度，禁用滚动，防止缩放等场景下出现横向滚动条

          setClass(ref, 'jmtd-table-disable-scroll-x', totalWidth <= offsetWidth); // 设置自动行高，去除自定义行
          // 自动行高：取最大行高为每一行的行高

          if (!noAutoRowHeight) {
            var rowHeight = Math.max.apply(Math, _toConsumableArray(bodyRowsRef.filter(function (el) {
              var _el$ROW;

              return !((_el$ROW = el[ROW]) !== null && _el$ROW !== void 0 && _el$ROW[CUSTOM_ROW]);
            }).map(function (el) {
              return Math.ceil(getSize(el).height);
            })));
            bodyRowsRef.forEach(function (el) {
              var _el$ROW2;

              if (!((_el$ROW2 = el[ROW]) !== null && _el$ROW2 !== void 0 && _el$ROW2[CUSTOM_ROW])) {
                css(el, 'height', px(rowHeight));
              }
            });
          } // 设置头部占位符的高度


          _toConsumableArray(theadRef.querySelectorAll('.jmtd-table-head-placeholder')).forEach(function (el) {
            css(el, 'height', px(findFirst(bubble(el), function (parent) {
              return parent.tagName.toUpperCase() === 'TH';
            }).clientHeight));
          });

          removeCss(ref, 'min-height');
          ref.classList.remove('jmtd-table-test');
          _this3.tableWidth = offsetWidth; // 计算带小数点的宽度

          thRef.forEach(function (el, index) {
            calcColumns[index].rawWidth = parseFloat(window.getComputedStyle(el).width);
          }); // TAG 计算列吸附

          calcColumns.forEach(function (_, index) {
            var affix = flatColumns[index].affix;

            if (affix) {
              var affixRight = affix === 'right';
              var affixName = getAffixAlign(affix);

              var getWidth = function getWidth(cols) {
                return cols.reduce(function (total, _ref7) {
                  var w = _ref7.rawWidth;
                  return total + w;
                }, 0);
              };

              var offsetColumns = affixRight ? calcColumns.slice(index + 1) : calcColumns.slice(0, index);
              var affixValue = getWidth(offsetColumns.filter(function (column) {
                return getAffixAlign(column.affix) === affixName;
              }));
              Object.assign(calcColumns[index], {
                offset: getWidth(offsetColumns),
                affixValue: affixValue,
                affixName: affixName
              });
              columnsRef[index].forEach(function (el) {
                if (el.hasAttribute('data-custom')) {
                  return;
                }

                affixCells.push(el);
                css(el, affixName, "".concat(affixValue, "px"));
              });
            } // 计算内滚动导致额表头吸顶


            if (scrollY) {
              var top = 0;

              var _iterator = _createForOfIteratorHelper(theadRef.children),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var theadRow = _step.value;

                  var _iterator2 = _createForOfIteratorHelper(theadRow.children),
                      _step2;

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      var th = _step2.value;
                      css(th, 'top', px(top));
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }

                  top += theadRow.offsetHeight;
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
          }); // 恢复滚动位置

          _this3.wrapperRef.scrollLeft = (_this3$lastScrollLeft = _this3.lastScrollLeft) !== null && _this3$lastScrollLeft !== void 0 ? _this3$lastScrollLeft : 0; // 处理滚动位置，设置列吸附等

          _this3.checkScrollX();
        })();
      } // TAG empty高度设置


      var empty = ref.querySelector('.jmtd-empty.jmtd-table-no-data');

      if (empty) {
        css(empty, 'top', px(theadRef.offsetHeight));
      }

      ref.querySelectorAll('.jmtd-table-fixed-cell').forEach(function (el) {
        css(el, 'width', px(offsetWidth));
      });
    }
  }, {
    key: "checkScrollX",
    value: function checkScrollX() {
      var ref = this.ref,
          affixCells = this.affixCells,
          wrapperRef = this.wrapperRef,
          tableWidth = this.tableWidth,
          calcColumns = this.calcColumns,
          hasAffix = this.hasAffix,
          headerAffixed = this.headerAffixed,
          theadRef = this.theadRef;
      var scrollLeft = wrapperRef.scrollLeft,
          scrollWidth = wrapperRef.scrollWidth;
      var scrollRight = scrollWidth - tableWidth - scrollLeft;
      var affixedLeftColumnIndex, affixedRightColumnIndex; // 记忆滚动位置

      this.lastScrollLeft = scrollLeft; // 处理吸顶滚动

      if (theadRef) {
        if (headerAffixed) {
          css(theadRef, {
            transform: "translate3d(".concat(px(-scrollLeft), ",0,0)"),
            clip: "rect(0, ".concat(px(scrollLeft + ref.offsetWidth), ", ").concat(px(theadRef.offsetHeight), ", ").concat(px(scrollLeft), ")")
          });
        } else {
          removeCss(theadRef, ['transform', 'clip']);
        }
      }

      if (!hasAffix) {
        return;
      }

      calcColumns.forEach(function (_ref8, index) {
        var affixName = _ref8.affixName,
            affixValue = _ref8.affixValue,
            offset = _ref8.offset;

        if (affixValue == null) {
          return;
        }

        var threshold = offset - affixValue;

        if (affixName === 'left' && scrollLeft > threshold) {
          var _affixedLeftColumnInd;

          affixedLeftColumnIndex = Math.max((_affixedLeftColumnInd = affixedLeftColumnIndex) !== null && _affixedLeftColumnInd !== void 0 ? _affixedLeftColumnInd : 0, index);
        } else if (affixName === 'right' && scrollRight - threshold > 1) {
          var _affixedRightColumnIn;

          affixedRightColumnIndex = Math.min((_affixedRightColumnIn = affixedRightColumnIndex) !== null && _affixedRightColumnIn !== void 0 ? _affixedRightColumnIn : Infinity, index);
        }
      });
      affixCells.forEach(function (el) {
        var columnIndex = el[COLUMN_INDEX];
        setClass(el, 'jmtd-table-cell-affixed', columnIndex === affixedLeftColumnIndex || columnIndex === affixedRightColumnIndex);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          columns = _this$props2.columns,
          dataSource = _this$props2.dataSource,
          size = _this$props2.size,
          bottomLeft = _this$props2.bottomLeft,
          bottomRight = _this$props2.bottomRight,
          affixHeader = _this$props2.affixHeader,
          loading = _this$props2.loading,
          tableClassName = _this$props2.className,
          getRowClassName = _this$props2.rowClassName,
          emptyDescription = _this$props2.emptyDescription,
          rowProps = _this$props2.rowProps,
          getCellProps = _this$props2.cellProps,
          tableProps = _this$props2.tableProps,
          scrollY = _this$props2.scrollY,
          rowKey = _this$props2.rowKey,
          dragProps = _this$props2.dragProps;
      var flatColumns = this.flatColumns = flat(columns);
      this.hasAffix = !!flatColumns.find(function (column) {
        return !!column.affix;
      });
      var rowsRef = this.rowsRef = [];
      var columnsRef = this.columnsRef = [];
      var thRef = this.thRef = [];
      var placeholderThRef = this.placeholderThRef = [];
      var colRefs = this.colRefs = [];
      var showBottom = !isEmpty(bottomLeft) || !isEmpty(bottomRight);
      var fAffixHeader = this.fAffixHeader = affixHeader || affixHeader === 0;
      var affixHeaderValue = this.affixHeaderValue = fAffixHeader ? affixHeader === true ? 0 : affixHeader : null;
      var emptyDataSource = dataSource.length === 0;
      var emptyColumns = columns.length === 0;
      var thLevels = getMaxLevel(columns); // th层级

      var thRows = []; // 表头tr数组

      var noChildColumnCount = 0; // 表头末级th计数

      var innerBordered = tableProps === null || tableProps === void 0 ? void 0 : tableProps.innerBordered; // 内边框 边框失效

      var outerBordered = tableProps === null || tableProps === void 0 ? void 0 : tableProps.outerBordered; // 外边框 边框失效
      // 渲染单元格

      function renderCell(decorators) {
        var raw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var arg = arguments.length > 2 ? arguments[2] : undefined;
        var props = arguments.length > 3 ? arguments[3] : undefined;

        var _ref9 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
            empty = _ref9.empty;

        if (empty) {
          return {
            children: null
          };
        }

        var _ref10 = !isObject(raw) || /*#__PURE__*/isValidElement(raw) ? {
          children: raw
        } : raw,
            children = _ref10.children,
            other = _objectWithoutProperties(_ref10, _excluded3);

        return _objectSpread({
          children: !decorators || raw !== null && raw !== void 0 && raw[CUSTOM_CELL] ? children : decorators.reduce(function (result, decorator) {
            return decorator(result, arg, {
              size: size
            });
          }, children)
        }, combineProps(other, props));
      } // 添加单元格到ref表中


      function addCellRef(el, column, index) {
        var columnRef = columnsRef[index] = columnsRef[index] || [];
        columnRef.push(el);
        el[COLUMN] = column;
        el[COLUMN_INDEX] = index;
      } // 计算Border


      function getCellBorder(innerStyle, outerStyle) {
        var th = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var top = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var bottom = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        var first = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
        var last = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

        var innerSty = _objectSpread({}, innerStyle);

        var outerSty = _objectSpread({}, outerStyle);

        var style = {};

        if (th) {
          // 表头
          delete innerSty.borderTop; // 内部border 删除borderTop

          delete innerSty.borderBottom; // 内部border 删除borderBottom

          delete innerSty.borderRight; // 内部border 删除borderRight

          first && delete innerSty.borderLeft; // 内部border first删除borderLeft

          delete outerSty.borderBottom; // 外部border 删除borderBottom

          !first && delete outerSty.borderLeft; // 外部border first保留borderLeft

          !last && delete outerSty.borderRight; // 外部border last保留borderRight

          style = _objectSpread(_objectSpread({}, innerSty), outerSty);
        } else {
          !top && delete innerSty.borderTop; // 内部border 删除borderTop

          delete innerSty.borderRight; // 内部border 删除borderRight

          first && delete innerSty.borderLeft; // 内部border first删除borderLeft

          delete outerSty.borderTop; // 外部border 删除borderTop

          !bottom && delete outerSty.borderBottom; // 最后一行保留Bottom

          !first && delete outerSty.borderLeft; // 外部border first保留borderLeft

          !last && delete outerSty.borderRight; // 外部border last保留borderRight

          style = _objectSpread(_objectSpread({}, innerSty), outerSty);
        }

        return style;
      } // 制作th row


      function makeThRows(list, level, baseColumnIndex) {
        var row = thRows[level] = thRows[level] || [];
        var colNumber = 0;
        list.forEach(function (column, index) {
          var children = column.children,
              title = column.title,
              decorator = column[TH_DECORATOR],
              onClick = column[ON_TH_CLICK],
              tooltip = column[TH_TOOLTIP],
              columnThProps = column[TH_PROPS];
          var colIndex = baseColumnIndex + colNumber;
          var className = {
            'jmtd-table-th-first-column': colIndex === 0
          };

          var props = _objectSpread(_objectSpread({}, columnThProps), {}, {
            onClick: onClick,
            tooltip: tooltip,
            className: className
          });

          if (hasChildren(children)) {
            // 分组单元格
            var colSpan = makeThRows(children, level + 1, colIndex);
            className['jmtd-table-group-th'] = true;
            Object.assign(props, {
              children: title,
              colSpan: colSpan
            });
            colNumber += colSpan;
          } else {
            // 底部单元格
            var rowSpan = thLevels - level;

            if (rowSpan > 1) {
              props.rowSpan = rowSpan;
            }

            var noChildColumnIndex = noChildColumnCount++;
            className['jmtd-table-none-group-th'] = true;
            Object.assign(props, renderCell(decorator, title), {
              cellRef: function cellRef(el) {
                thRef[noChildColumnIndex] = el;
                addCellRef(el, column, noChildColumnIndex);
              }
            });
            colNumber += 1;
          }

          var extraStyle = getCellBorder(innerBordered, outerBordered, true, false, false, index === 0, index === list.length - 1);
          row.push( /*#__PURE__*/React.createElement(Cell, _extends({
            key: colIndex
          }, props, {
            props: column.thProps,
            column: column,
            CellTag: "th",
            extraStyle: extraStyle
          })));
        });
        return colNumber;
      }

      makeThRows(columns, 0, 0);
      var tableCLassName = classNames('jmtd-table', tableClassName, {
        'jmtd-table-with-head-group': thLevels > 1,
        'jmtd-table-large': size === 'large',
        'jmtd-table-small': size === 'small',
        'jmtd-table-mini': size === 'mini',
        'jmtd-table-affix-header': fAffixHeader,
        'jmtd-table-scroll-y': scrollY
      });

      function Row(_ref11) {
        var _ref11$props = _ref11.props;
        _ref11$props = _ref11$props === void 0 ? {} : _ref11$props;

        var propsClassName = _ref11$props.className,
            otherProps = _objectWithoutProperties(_ref11$props, _excluded4),
            _ref11$Tag = _ref11.Tag,
            Tag = _ref11$Tag === void 0 ? 'tr' : _ref11$Tag,
            render = _ref11.render,
            key = _ref11.key,
            CellTag = _ref11.CellTag,
            rowClassName = _ref11.rowClassName,
            _ref11$getProps = _ref11.getProps,
            getProps = _ref11$getProps === void 0 ? function () {
          return {};
        } : _ref11$getProps,
            _ref11$rowRefAttrs = _ref11.rowRefAttrs,
            rowRefAttrs = _ref11$rowRefAttrs === void 0 ? {} : _ref11$rowRefAttrs,
            _ref11$rowRef = _ref11.rowRef,
            rowRef = _ref11$rowRef === void 0 ? function (el) {
          if (el) {
            Object.assign(el, rowRefAttrs);
            rowsRef.push(el);
          }
        } : _ref11$rowRef,
            _ref11$ref = _ref11.ref,
            ref = _ref11$ref === void 0 ? function () {} : _ref11$ref;

        return /*#__PURE__*/React.createElement(Tag, _extends({
          className: classNames(RowClassName, rowClassName, propsClassName)
        }, otherProps, {
          key: key,
          ref: rowRef
        }), flatColumns.map(function (column, index) {
          var extraStyle = getCellBorder(innerBordered, outerBordered, false, key === 0, key === dataSource.length - 1, index === 0, index === flatColumns.length - 1);
          return /*#__PURE__*/React.createElement(Cell, _extends({
            key: index
          }, combineProps(getProps(column), render(column, index)), {
            CellTag: CellTag,
            column: column,
            cellRef: function cellRef(el) {
              addCellRef(el, column, index);
              ref(el, index);
            },
            extraStyle: extraStyle
          }));
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        id: id,
        "data-component-name": "Table",
        ref: function ref(el) {
          _this4.ref = el;
        },
        className: tableCLassName
      }, /*#__PURE__*/React.createElement(Loading, {
        loading: loading
      }, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-table-wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-table-scroll-wrapper",
        ref: function ref(el) {
          _this4.wrapperRef = el;
        },
        onScroll: function onScroll() {
          _this4.checkScrollX();
        },
        style: {
          maxHeight: scrollY
        }
      }, !emptyColumns && /*#__PURE__*/React.createElement("table", {
        className: "jmtd-table-main",
        cellSpacing: "0",
        cellPadding: "0",
        border: "0",
        ref: function ref(el) {
          _this4.tableRef = el;
        }
      }, Row({
        Tag: 'colgroup',
        CellTag: 'col',
        render: function render() {
          return '';
        },
        ref: function ref(el, colIndex) {
          colRefs[colIndex] = el;
        }
      }), /*#__PURE__*/React.createElement("thead", {
        ref: function ref(el) {
          _this4.theadRef = el;
        },
        className: "jmtd-table-head",
        style: fAffixHeader ? {
          top: affixHeaderValue
        } : {}
      }, thRows.map(function (cells, index) {
        return /*#__PURE__*/React.createElement("tr", {
          className: RowClassName,
          key: index
        }, cells);
      })), fAffixHeader && /*#__PURE__*/React.createElement("thead", {
        className: "jmtd-table-head-affix-placeholder"
      }, Row({
        CellTag: 'th',
        render: function render() {
          return '';
        },
        rowRef: function rowRef(el) {
          _this4.headerPlaceholderRef = el;
        },
        ref: function ref(el, colIndex) {
          placeholderThRef[colIndex] = el;
        }
      })), /*#__PURE__*/React.createElement("tbody", {
        className: "jmtd-table-body"
      }, dataSource.map(function (record, rowIndex) {
        var key = rowKey ? getObjectValue(record, rowKey, rowIndex) : rowIndex;
        return Row({
          rowClassName: classNames(getRowClassName(record, rowIndex), {
            'jmtd-table-empty-row': record[EMPTY_ROW]
          }),
          CellTag: 'td',
          props: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, getValue(rowProps, record, rowIndex)), record[EMPTY_ROW]), dragProps), {}, {
            'data-row-key': rowIndex
          }),
          rowRefAttrs: _defineProperty({}, ROW, record),
          render: function render(column, columnIndex) {
            var dataIndex = column.dataIndex,
                _column$render = column.render,
                render = _column$render === void 0 ? defaultColumnRender : _column$render,
                decorator = column[TD_DECORATOR];
            var renderArgs = [dataIndex != null ? record[dataIndex] : '', record, rowIndex, tableProps];
            return renderCell(decorator, render.apply(void 0, renderArgs), record, getValue.apply(void 0, [getCellProps].concat(_toConsumableArray(renderArgs.concat({
              column: column,
              columnIndex: columnIndex
            })))), {
              empty: record[EMPTY_ROW]
            });
          },
          key: key
        });
      }))), emptyColumns && /*#__PURE__*/React.createElement("div", {
        className: "jmtd-table-head",
        ref: function ref(el) {
          _this4.theadRef = el;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-table-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-table-cell"
      }, "\xA0"))), emptyDataSource && /*#__PURE__*/React.createElement("div", {
        className: "jmtd-table-no-data"
      })), emptyDataSource && /*#__PURE__*/React.createElement(Empty, {
        className: "jmtd-table-no-data",
        description: emptyDescription
      })), showBottom && /*#__PURE__*/React.createElement("div", {
        className: "jmtd-table-bottom"
      }, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-table-bottom-left"
      }, bottomLeft), /*#__PURE__*/React.createElement("div", {
        className: "jmtd-table-bottom-right"
      }, bottomRight))));
    }
  }]);

  return TableKernel;
}(PureComponent);

export { TableKernel as default };
TableKernel.propTypes = {
  id: PropTypes.string,
  columns: PropTypes.any.isRequired,
  dataSource: PropTypes.any.isRequired,
  size: PropTypes.oneOf(['mini', 'small', 'middle', 'large']),
  bottomLeft: PropTypes.node,
  bottomRight: PropTypes.node,
  loading: PropTypes.bool,
  affixHeader: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  className: PropTypes.string,
  emptyDescription: PropTypes.node,
  rowClassName: PropTypes.func,
  rowProps: PropTypes.func,
  cellProps: PropTypes.func,
  tableProps: PropTypes.object,
  scrollY: PropTypes.number,
  noAutoRowHeight: PropTypes.bool,
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.symbol, PropTypes.func]),
  dragProps: PropTypes.object
};
TableKernel.defaultProps = {
  id: null,
  size: null,
  bottomLeft: null,
  bottomRight: null,
  loading: false,
  affixHeader: false,
  className: '',
  emptyDescription: undefined,
  rowClassName: function rowClassName() {
    return null;
  },
  rowProps: function rowProps() {
    return undefined;
  },
  cellProps: function cellProps() {
    return undefined;
  },
  tableProps: {},
  scrollY: null,
  noAutoRowHeight: false,
  rowKey: null,
  dragProps: {}
};